import { useState } from 'react';
import { motion } from 'framer-motion';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const ProjectsPage = () => {
  const [activeFilter, setActiveFilter] = useState<'all' | 'towers' | 'commercial' | 'infrastructure' | 'industrial'>('all');

  const projects = [
    {
      id: 1,
      title: 'برج الرياض التجاري',
      location: 'الرياض',
      category: 'towers',
      duration: '18 شهر',
      cranes: '8 رافعات ثقيلة',
      capacity: '160-300 طن',
      floors: '45 طابق',
      description: 'مشروع برج تجاري ضخم في قلب العاصمة الرياض، استخدمنا فيه أحدث الرافعات الثقيلة لضمان الدقة والسلامة',
      image: 'massive construction project tall skyscraper building in Riyadh Saudi Arabia with multiple yellow cranes working, modern urban development, sunset golden hour lighting, wide angle aerial view, professional architecture photography',
      tags: ['أبراج', 'تجاري', 'رافعات ثقيلة'],
    },
    {
      id: 2,
      title: 'مجمع الأعمال الشرقي',
      location: 'الدمام',
      category: 'commercial',
      duration: '12 شهر',
      cranes: '4 رافعات متوسطة',
      capacity: '50-130 طن',
      floors: '25 طابق',
      description: 'مجمع أعمال متكامل يضم مكاتب ومحلات تجارية في المنطقة الشرقية',
      image: 'commercial business complex construction with yellow cranes, modern glass building in eastern Saudi Arabia, daytime clear sky, professional construction site photography',
      tags: ['تجاري', 'مكاتب', 'رافعات متوسطة'],
    },
    {
      id: 3,
      title: 'مشروع الطرق السريعة',
      location: 'جدة',
      category: 'infrastructure',
      duration: '24 شهر',
      cranes: '12 رافعة متنوعة',
      capacity: '7-160 طن',
      floors: '-',
      description: 'مشروع بنية تحتية ضخم لتطوير شبكة الطرق السريعة في جدة',
      image: 'highway infrastructure construction project with multiple cranes building bridge overpass in Saudi Arabia, road development, heavy construction equipment, aerial view photography',
      tags: ['بنية تحتية', 'طرق', 'جسور'],
    },
    {
      id: 4,
      title: 'مصنع الصناعات الثقيلة',
      location: 'الجبيل',
      category: 'industrial',
      duration: '20 شهر',
      cranes: '10 رافعات ثقيلة',
      capacity: '130-300 طن',
      floors: '-',
      description: 'مشروع صناعي ضخم لإنشاء مصنع للصناعات الثقيلة في المدينة الصناعية',
      image: 'heavy industrial factory construction site with massive yellow cranes, steel structure installation, industrial zone in Saudi Arabia, professional construction photography',
      tags: ['صناعي', 'مصانع', 'رافعات ثقيلة'],
    },
    {
      id: 5,
      title: 'مول العاصمة الكبير',
      location: 'الرياض',
      category: 'commercial',
      duration: '16 شهر',
      cranes: '6 رافعات متوسطة',
      capacity: '50-130 طن',
      floors: '4 طوابق',
      description: 'مركز تسوق ضخم يضم أكثر من 300 محل تجاري ومرافق ترفيهية',
      image: 'large shopping mall construction with yellow cranes, modern commercial building, Riyadh Saudi Arabia, construction site photography',
      tags: ['تجاري', 'مول', 'ترفيه'],
    },
    {
      id: 6,
      title: 'مشروع الإسكان الحديث',
      location: 'المدينة المنورة',
      category: 'towers',
      duration: '14 شهر',
      cranes: '5 رافعات خفيفة ومتوسطة',
      capacity: '7-50 طن',
      floors: '15 طابق',
      description: 'مجمع سكني حديث يضم 8 أبراج سكنية بمواصفات عالية الجودة',
      image: 'modern residential towers construction with yellow cranes, apartment buildings, Medina Saudi Arabia, construction photography',
      tags: ['سكني', 'أبراج', 'إسكان'],
    },
    {
      id: 7,
      title: 'جسر الملك فهد الجديد',
      location: 'الخبر',
      category: 'infrastructure',
      duration: '30 شهر',
      cranes: '15 رافعة متنوعة',
      capacity: '50-300 طن',
      floors: '-',
      description: 'مشروع جسر ضخم يربط بين مناطق حيوية في المنطقة الشرقية',
      image: 'massive bridge construction project with multiple cranes, concrete structure, Saudi Arabia infrastructure, dramatic engineering photography',
      tags: ['بنية تحتية', 'جسور', 'هندسة'],
    },
    {
      id: 8,
      title: 'مجمع المستشفيات الطبي',
      location: 'جدة',
      category: 'commercial',
      duration: '22 شهر',
      cranes: '7 رافعات متوسطة',
      capacity: '50-130 طن',
      floors: '12 طابق',
      description: 'مجمع طبي متكامل يضم مستشفيات ومراكز طبية متخصصة',
      image: 'medical hospital complex construction with yellow cranes, modern healthcare building, Jeddah Saudi Arabia, professional construction photography',
      tags: ['طبي', 'مستشفيات', 'صحة'],
    },
    {
      id: 9,
      title: 'محطة معالجة المياه',
      location: 'الطائف',
      category: 'infrastructure',
      duration: '18 شهر',
      cranes: '8 رافعات متنوعة',
      capacity: '19-160 طن',
      floors: '-',
      description: 'مشروع بنية تحتية حيوي لمعالجة وتوزيع المياه',
      image: 'water treatment plant construction with cranes, industrial infrastructure project, Saudi Arabia, engineering photography',
      tags: ['بنية تحتية', 'مياه', 'خدمات'],
    },
  ];

  const filteredProjects = activeFilter === 'all' 
    ? projects 
    : projects.filter(p => p.category === activeFilter);

  const categories = [
    { id: 'all', name: 'جميع المشاريع', icon: 'ri-apps-line' },
    { id: 'towers', name: 'الأبراج', icon: 'ri-building-line' },
    { id: 'commercial', name: 'تجاري', icon: 'ri-store-line' },
    { id: 'infrastructure', name: 'بنية تحتية', icon: 'ri-road-map-line' },
    { id: 'industrial', name: 'صناعي', icon: 'ri-factory-line' },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-96 flex items-center justify-center overflow-hidden mt-20">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/dc50f54f1cc8ac93a72198b8727f54f3.jpg"
            alt="مشاريعنا"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-primary/75"></div>
        </div>

        <div className="relative z-10 container mx-auto px-6 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-6xl md:text-7xl font-black text-white mb-6">مشاريعنا</h1>
            <p className="text-2xl text-accent font-bold">+500 مشروع منجز بنجاح في جميع أنحاء المملكة</p>
          </motion.div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { icon: 'ri-building-line', value: '500+', label: 'مشروع منجز' },
              { icon: 'ri-map-pin-line', value: '13', label: 'مدينة' },
              { icon: 'ri-team-line', value: '150+', label: 'عميل راضٍ' },
              { icon: 'ri-award-line', value: '100%', label: 'نسبة النجاح' },
            ].map((stat, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-white rounded-2xl p-6 text-center shadow-lg"
              >
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                  <i className={`${stat.icon} text-5xl text-accent`}></i>
                </div>
                <div className="text-4xl font-black text-primary mb-2">{stat.value}</div>
                <p className="text-gray-600 font-semibold">{stat.label}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Filter Section */}
      <section className="py-12 bg-white sticky top-20 z-40 shadow-md">
        <div className="container mx-auto px-6">
          <div className="flex flex-wrap justify-center gap-3">
            {categories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => setActiveFilter(cat.id as any)}
                className={`px-6 py-3 rounded-full font-bold text-base transition-all whitespace-nowrap inline-flex items-center gap-2 ${
                  activeFilter === cat.id
                    ? 'bg-accent text-primary shadow-lg scale-105'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
              >
                <i className={`${cat.icon} text-xl`}></i>
                <span>{cat.name}</span>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Projects Grid */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredProjects.map((project, index) => (
              <motion.div
                key={project.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all group cursor-pointer"
              >
                {/* Image */}
                <div className="relative h-72 overflow-hidden">
                  <img
                    src={`https://readdy.ai/api/search-image?query=$%7Bproject.image%7D&width=600&height=500&seq=project-${project.id}-001&orientation=squarish`}
                    alt={project.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-primary/90 via-primary/40 to-transparent"></div>
                  
                  {/* Location Badge */}
                  <div className="absolute top-4 right-4">
                    <div className="bg-white/20 backdrop-blur-md px-4 py-2 rounded-full flex items-center gap-2">
                      <i className="ri-map-pin-fill text-accent"></i>
                      <span className="text-white font-bold text-sm">{project.location}</span>
                    </div>
                  </div>

                  {/* Title Overlay */}
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <h3 className="text-2xl font-black text-white mb-2">{project.title}</h3>
                  </div>
                </div>

                {/* Content */}
                <div className="p-6">
                  <p className="text-gray-700 mb-4 leading-relaxed">{project.description}</p>

                  {/* Project Details */}
                  <div className="space-y-3 mb-6">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 flex items-center justify-center bg-accent/10 rounded-lg">
                        <i className="ri-truck-line text-accent text-lg"></i>
                      </div>
                      <div>
                        <p className="text-xs text-gray-500">الرافعات المستخدمة</p>
                        <p className="text-sm font-bold text-primary">{project.cranes}</p>
                      </div>
                    </div>

                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 flex items-center justify-center bg-accent/10 rounded-lg">
                        <i className="ri-time-line text-accent text-lg"></i>
                      </div>
                      <div>
                        <p className="text-xs text-gray-500">مدة المشروع</p>
                        <p className="text-sm font-bold text-primary">{project.duration}</p>
                      </div>
                    </div>

                    {project.floors !== '-' && (
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 flex items-center justify-center bg-accent/10 rounded-lg">
                          <i className="ri-building-line text-accent text-lg"></i>
                        </div>
                        <div>
                          <p className="text-xs text-gray-500">عدد الطوابق</p>
                          <p className="text-sm font-bold text-primary">{project.floors}</p>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Tags */}
                  <div className="flex flex-wrap gap-2">
                    {project.tags.map((tag, idx) => (
                      <span
                        key={idx}
                        className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full text-xs font-semibold"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-primary">
        <div className="container mx-auto px-6 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="w-24 h-24 flex items-center justify-center bg-accent rounded-full mx-auto mb-8">
              <i className="ri-chat-quote-fill text-5xl text-primary"></i>
            </div>
            <h2 className="text-5xl md:text-6xl font-black text-white mb-6">
              هل لديك مشروع قادم؟
            </h2>
            <p className="text-2xl text-gray-300 mb-12 max-w-3xl mx-auto">
              دعنا نكون شريكك في النجاح. تواصل معنا الآن للحصول على استشارة مجانية
            </p>
            <div className="flex flex-wrap justify-center gap-6">
              <a
                href="tel:920000000"
                className="bg-accent hover:bg-accent-dark text-primary px-12 py-5 rounded-xl font-black text-xl transition-all shadow-2xl hover:shadow-accent/50 hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-3"
              >
                <i className="ri-phone-fill text-2xl"></i>
                <span>اتصل بنا الآن</span>
              </a>
              <a
                href="/contact"
                className="bg-transparent border-4 border-white hover:bg-white hover:text-primary text-white px-12 py-5 rounded-xl font-bold text-xl transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-3"
              >
                <i className="ri-mail-fill text-2xl"></i>
                <span>أرسل طلبك</span>
              </a>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ProjectsPage;